
if (/*@cc_on!@*/false && document.documentMode === 10) {
	document.documentElement.className+=' ie10';
}

var $filterSizeSlider;
var $filterBedsSlider;

function createFilterString() {
	var cFilter = "";
	var cCurrentFilter = "";
	var cFilterItem = "";
	$(".filters .filter__item input:checked").each(function() {
		cFilter += (cFilterItem === $(this).attr("name") ? "," : "") + (cFilterItem === $(this).attr("name") ? "" : (cFilter === "" ? "?" : "&") + $(this).attr("name") + "=") + $(this).attr("value");
		cFilterItem = $(this).attr("name");
	});

	if (parseInt($filterSizeSlider.slider("option", "min")) !== parseInt($filterSizeSlider.slider("option", "values")[0])) {
		cFilter += (cFilter === "" ? "?" : "&") + "groepsgrootte-min=" + $filterSizeSlider.slider("option", "values")[0];
	}
	if (parseInt($filterSizeSlider.slider("option", "max")) !== parseInt($filterSizeSlider.slider("option", "values")[1])) {
		cFilter += (cFilter === "" ? "?" : "&") + "groepsgrootte-max=" + $filterSizeSlider.slider("option", "values")[1];
	}
	if (parseInt($filterBedsSlider.slider("option", "min")) !== parseInt($filterBedsSlider.slider("option", "values")[0])) {
		cFilter += (cFilter === "" ? "?" : "&") + "slaapplaatsen-min=" + $filterBedsSlider.slider("option", "values")[0];
	}
	if (parseInt($filterBedsSlider.slider("option", "max")) !== parseInt($filterBedsSlider.slider("option", "values")[1])) {
		cFilter += (cFilter === "" ? "?" : "&") + "slaapplaatsen-max=" + $filterBedsSlider.slider("option", "values")[1];
	}
	$(".filter--stars a.active").each(function() {
		var stars = parseInt($(this).attr("data-stars"));
		cFilter += (cFilter === "" ? "?" : "&") + "luxe=" + stars;
	});

	cFilter += "#filter--start";

	return cFilter;
}

$(function(){

  // Toggle Items
  var body = $('body');
  var toggleMenu = $('#toggleMenu');
  var hamburger = $('.hamburger');
  var openModal = $('.js-open-modal');
  var closeModal = $('.js-close-modal');

  toggleMenu.on("click", function(e) {
    body.toggleClass('body--show-menu');
    hamburger.toggleClass('is-active');
    e.preventDefault();
  });

  openModal.on("click", function(e) {
    body.toggleClass('body--show-modal');
    e.preventDefault();
  });

  closeModal.on("click", function(e) {
    body.toggleClass('body--show-modal');
    e.preventDefault();
  });

	// Toggle Menu
  $('.topmenu__item--toggle').on("click", function(e) {
    body.toggleClass('show-menu');
    e.preventDefault();
  });

	// // TOGGLE RESPONSIVE MENU
	// $(".navigation__open").on("click", function(e) {
	// 	$(".menu--main").removeClass("menu--closed");
	// 	e.preventDefault();
	// });

	$(".navigation__close").on("click", function(e) {
		$(".menu--main").addClass("menu--closed");
		e.preventDefault();
	});

	// TOGGLE FILTERS
	$(".filters__title").on("click", function() {
		$(this).closest(".filters").toggleClass("filters--open");
		$(this).find(".filters__toggle").toggleClass("fa-chevron-down").toggleClass("fa-chevron-up");
	});

	$(".filter__toggle, .filter__title").on("click", function() {
		$(this).closest(".filter").toggleClass("filter--closed");
		$(this).closest(".filter").find(".filter__toggle .fa").toggleClass("fa-angle-down").toggleClass("fa-angle-up");
	});

	$(".filter--stars a").on("mouseover", function() {
		var stars = parseInt($(this).attr("data-stars"));
		$(this).closest(".filter--stars").find("a").each(function() {
			if (parseInt($(this).attr("data-stars")) <= stars) {
				$(this).addClass("hover");
			} else {
				$(this).addClass("hover--none");
			}
		});
	}).on("mouseout", function() {
		$(this).closest(".filter--stars").find("a").removeClass("hover hover--none");
	}).on("click", function() {
		$(this).closest(".filter--stars").find(".active, .sub-active").removeClass("active sub-active");
		var stars = parseInt($(this).attr("data-stars"));
		$(this).closest(".filter--stars").find("a").each(function() {
			if (parseInt($(this).attr("data-stars")) < stars) {
				$(this).addClass("sub-active");
			}
		});
		$(this).addClass("active");

		document.location = "/" + createFilterString();

	});

	$(".filter__item input").change(function() {
		document.location = "/" + createFilterString();
	});

	// FILTER SLIDER
	$filterSizeSlider = $("#filter--size-slider").slider({
		range: true,
		min: 0,
		max: 50,
		values: [$("#filter--size-slider--min").val(), $("#filter--size-slider--max").val()],
		step: 5,
		slide: function(event, ui) {
			$("#filter--size-slider--min").val(ui.values[0]);
			$("#filter--size-slider--max").val(ui.values[1]);
		},
		stop: function(event, ui) {
			document.location = "/" + createFilterString();
		}
	});
	$filterBedsSlider = $("#filter--beds-slider").slider({
		range: true,
		min: 0,
		max: 50,
		values: [$("#filter--beds-slider--min").val(), $("#filter--beds-slider--max").val()],
		step: 5,
		slide: function(event, ui) {
			$("#filter--beds-slider--min").val(ui.values[0]);
			$("#filter--beds-slider--max").val(ui.values[1]);
		},
		stop: function(event, ui) {
			document.location = "/" + createFilterString();
		}
	});

	$(".widget__pages").owlCarousel({
		singleItem: true
		// autoHeight: true
	});

	$(".lastminutes__list").owlCarousel({
		singleItem: true,
		// autoHeight: true
	});

	// TABS
	$(".tabs .tab__switch").on("click", function() {
		var $tab = $(this).closest(".tabs").find("." + $(this).attr("data-tab-for"));
		$(this).closest(".tabs").find(".tab__switch--active").removeClass("tab__switch--active");
		$(this).closest(".tabs").find(".tab--active").removeClass("tab--active");
		$tab.addClass("tab--active");
		$(this).addClass("tab__switch--active");
	});
	$(".tabs").each(function() {
		$(this).find(".tab__switch--1 .tab__count").text($(this).find(".tab--1 .catalog__item").length);
		$(this).find(".tab__switch--2 .tab__count").text($(this).find(".tab--2 article").length);
	});

	// NAAR PAGINA NA FILTEREN


	// RETINA
	$.cookie("isRetina", window.devicePixelRatio > 1, { path: "/" });


	// PLACEHOLDER
	$('[placeholder]').placeholder();

	// REMOVE MARGIN BIJ OPEENVOLGENDE AFBEELDINGEN
	$("figure.left, figure.right").each(function() {
		if ($(this).next("figure.left, figure.right").length >= 1) {
			if (!$(this).hasClass("no-margin")) {
				$(this).next().addClass("no-margin").after("<div class=\"clear\"></div>");
			}
		}
	});

	// CLEAR CALL TO ACTIONS
	$("a.btn").each(function(){
		if ($(this).prev(".btn").length < 0) {
			$(this).before("<div class=\"clear\"></div>");
		}
		if ($(this).next(".btn").length < 0) {
			$(this).after("<div class=\"clear\"></div>");
		}
	});

	var videoHeight = $('.video').height();

	$(function() {

		var videoCalc = videoHeight/4;
		//console.log(videoHeight);
		$('.video, .ytplayer-player, #ytplayer-container1490348443479').css("top", -videoCalc);
		//console.log(videoCalc);
	});
}); // END FUNCTION